import React, { useState, useEffect } from "react";
import { Container, Row, Col, Modal, Nav, Form } from "react-bootstrap";
import PostCard from "./PostCard";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowCircleUp,
  faCircleNotch,
  faHandPeace,
  faPeace,
} from "@fortawesome/free-solid-svg-icons";
import Button from "@restart/ui/esm/Button";
import { LinkContainer } from "react-router-bootstrap";

const HomeScreen = ({ match }) => {
  const keyword = match.params.keyword;
  const [posts, setPosts] = useState([]);
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(true);
  const [show, setShow] = useState(false);
  const [category, setCategory] = useState("all");

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    const fetchPosts = async (keyword = "") => {
      const { data } = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/posts?keyword=${keyword}`
      );
      setPosts(data);
      setLoading(false);
    };

    fetchPosts(keyword);

    window.addEventListener("scroll", () => {
      if (window.pageYOffset > 300) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    });
  }, [keyword]);

  const scrollToTop = (e) => {
    e.preventDefault();

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      <Container className="pt-5 text-center" id="postContainer">
        <LinkContainer to="/madebyme">
          <Button
            id="mdm"
            className="btn btn-secondary btn-outline-dark shadow-lg"
          >
            Mines
          </Button>
        </LinkContainer>
        <Button
          id="about"
          className="btn btn-secondary btn-outline-dark shadow-lg"
          onClick={handleShow}
        >
          About
        </Button>

        <Row style={{ marginBottom: "3rem", justifyContent: "end" }}>
          <Form.Select
            size="sm"
            style={{ width: "fit-content" }}
            value={category}
            onChange={(e) => setCategory(e.target.value)}
          >
            <option value="all">All</option>
            <option value="funweb">FunWebs</option>
            <option value="learn">Learn</option>
            <option value="visualizer">Visualizer</option>
            <option value="art">Art</option>
            <option value="tool">Tools</option>
            <option value="music">Musics</option>
            <option value="ai">AI</option>
            <option value="game">Games</option>
            <option value="simulation">Simulation</option>
            <option value="sound">Sounds</option>
            <option value="history">History</option>
            <option value="killtime">KillTime</option>
            <option value="movie">Movies</option>
            <option value="ambience">Ambience</option>
            <option value="other">Others</option>
          </Form.Select>
        </Row>
        {loading && (
          <FontAwesomeIcon icon={faCircleNotch} size="3x" className="fa-spin" />
        )}
        <Row xs={1} md={2} lg={3}>
          {category !== "all"
            ? posts
                .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
                .filter(
                  (postByCate) => postByCate.category === category.toString()
                )
                .map((post) => (
                  <Col key={post._id}>
                    <PostCard post={post} />
                  </Col>
                ))
            : posts
                .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
                .map((post) => (
                  <Col key={post._id}>
                    <PostCard post={post} />
                  </Col>
                ))}
        </Row>
        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>About</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ padding: "2rem" }}>
            This website is based on sharing/showcasing awesome, usually minimal
            and single purpose webtools and webapps. New Apps Added Weekly!.
            <br></br>
            Created and Compiled by{" "}
            <Nav.Link
              href="https://twitter.com/Rahul_ion011"
              target="_blank"
              style={{
                display: "inline",
                padding: "0",
                color: "black",
                textDecoration: "underline",
              }}
            >
              Rahul.
            </Nav.Link>
            <br></br>
            <LinkContainer to="/privacy">
              <a href="/#">Privacy & Policy</a>
            </LinkContainer>
            <br></br>Peace Out <FontAwesomeIcon icon={faHandPeace} />
            <FontAwesomeIcon icon={faPeace} className="fa-spin" />
          </Modal.Body>
        </Modal>
      </Container>
      {visible && (
        <Button
          style={{ background: "transparent", border: "none" }}
          id="back-to-top"
        >
          <FontAwesomeIcon
            onClick={scrollToTop}
            icon={faArrowCircleUp}
            size="3x"
            style={{ color: "#343a40", display: visible ? "inline" : "none" }}
          />
        </Button>
      )}
    </>
  );
};

export default HomeScreen;
